import { Injectable } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';
import { DialogsService } from 'src/app/_services/dialogs.service';

import * as _ from 'lodash';
import moment from 'moment';
declare const $: any;

@Injectable({
	providedIn: 'root'
})
export class GeneralUtilsService {

    CONSTS: any = {
        storageToken: "tabit_co",
        storageToken_keys: "tabit_co_keys",
        tdTypeMap: {
            "takeaway": "TA",
            "eatin": "OTC",
            "delivery": "Delivery"
        },
        tdServiceTypeMap: {
            "eatin": "seated"
        },
        tdOrderTypeMap: {
            "Seated": "eatin",
            "Delivery": "delivery",
            "TA": "takeaway"
        },
        tdTenderMap: {
            "CASH": "cash",
            "CREDIT": "creditCard",
            "CIBUS": "Cibus",
            "TENBIS": "10bis"
        },
        AUTH_EXP_THRESHOLD_MS: 60000
    }

    constructor(
        public appService: AppService,
        public entityService: EntityService,
        public dialogsService: DialogsService,
    ) {

    }

	getSMSverificationCode(args, isRetry, organization?) {
		_.extend(args, { deviceId: this.appService.clientId });
		return this.entityService.post("/online-shopper/verification", args, { 'ros-organization': organization }).then(res => {
			return this.dialogsService.showSMSDialog(_.extend(args, { isRetry: isRetry })).then(response => {
				if (response === "resend") return this.getSMSverificationCode(args, isRetry, organization);
				return response;
			}).catch(err => {
				throw ({ type: 'CANCELED' });
			})
		}).catch(err => {
			throw (err);
		})
	}

    ccInfoToWalletPayment (ccinfo) {
        if (ccinfo && !ccinfo.$$isExternal) {
			const parsedPayment = this.getPreparedPayment(ccinfo);
			let pan = parsedPayment.cardNum;
			if (pan) pan = pan.toString();

            const res: any = {
                paymentType: parsedPayment.paymentType,
                pan,
                expMonth: parsedPayment.expMonth,
                expYear: parsedPayment.expYear,
                brand: ccinfo.type,
				ownerName: parsedPayment.name,
				comment: ccinfo.comment,
				idCard: ccinfo.idCard
			}
			return res;
        }
    };

    getCVV(card) {
		this.appService.sendAnalyticsEvent('screen_view', { screen_name: 'cvv' });
        return this.appService.prompt({
			content: 'ENTER_CVV',
			label: 'CVV',
			numeric: true
        }).catch(err => {
            throw {
                type: 'CANCELED',
                message: "CANCELED",
            };
        });
    }

	checkForIdCard(ccinfo) {
		// Don't check for ID card for CreditCard || CreditGuard
		if (ccinfo.idCard || !ccinfo.requireIdPhoneTrans || ['creditCard', 'creditGuard'].includes(ccinfo.paymentType)) return Promise.resolve();
		let paymentId = ccinfo.walletPayment;
		if (paymentId) {
			let idCard = this.restoreKEY('wpic_' + paymentId);
			if (idCard) {
				ccinfo.idCard = idCard;
				return Promise.resolve();
			}
		}
		return this.appService.prompt({
			content: this.appService.translate("ENTER_IDCARD_MESSAGE", { card: ccinfo.pan || ccinfo.displayPan }),
			label: 'ENTER_IDCARD',
			template: 'idCard',
			contentClass: 'text-base font-bold pb-3'
		}).then(res => {
			this.cacheKEY('wpic_' + paymentId, res);
			ccinfo.idCard = res;
			return;
		});
	}

	checkForSignature($storage, ccinfo) {
		if (!$storage.requiereCreditSign || ['creditCard', 'creditGuard'].includes(ccinfo.paymentType)) {
			return Promise.resolve();
		} else {
			return this.appService.getSignature()
				.then((signature) => {
					ccinfo.signature = signature;
					return;
				});
		}
	}

	showMessageWithPhone(message, phone) {
		return Promise.resolve();
	}

    serverErrorToAppError (serverError) {
        if (!serverError) return;
        if (serverError?.data?.code === 409001) {
            return {
                type: 'SERVER_ERROR',
                message: this.appService.translate("MESSAGES.ORDER_HELD_BY_SERVER"),
                serverError
            }
        }
    };

	restoreKEY(key) {
		return this.appService.restoreKEY(key);
    };

    cacheKEY (key, val) {
		return this.appService.cacheKEY(key, val);
    };

    getPreparedPayment(pinfo) {
        var amount = Math.round(pinfo.amount * 100);// || order.balanceDue || order.grandTotal) * 100);
        var tip = null;
        if (pinfo.tip) {
            tip = { amount: Math.round(pinfo.tip * 100) }
        }

        if (pinfo.walletPayment || pinfo.walletPaymentMethodId) {
			return {
				_id: this.appService.getObjectId(),
				checkId: pinfo.checkId,
                paymentType: pinfo.paymentType,
                walletPayment: pinfo.walletPayment,
                walletPaymentMethodId: pinfo.walletPaymentMethodId,
                amount,
                tip,
                customerDetails: pinfo.customerDetails,
				deviceId: this.appService.clientId,
				account: pinfo.account,
				merchantNumber: pinfo.merchantNumber
            }
        } else {
			const base: any = {
				_id: this.appService.getObjectId(),
				checkId: pinfo.checkId,
				paymentType: pinfo.paymentMethod,
                cardNum: pinfo.pan,
                amount: amount,
                customerDetails: pinfo.customerDetails,
                tip: tip,
				$$isExternal: pinfo.$$isExternal,
				deviceId: this.appService.clientId,
				account: pinfo.account,
				merchantNumber: pinfo.merchantNumber,
				verificationDetails: {
					zipCode: pinfo.zip,
					address1: pinfo.address,
					city: pinfo.city,
					state: pinfo.state,
				}
            }
            // Support Google/Apple Pay
            if ((["creditGuard", "CreditGuard"]).includes(pinfo.paymentMethod) && pinfo.providerInfo) {
                base.providerInfo = pinfo.providerInfo;
            }

            if (pinfo.$$isExternal) return base;

            switch (pinfo.paymentMethod) {
                case "creditCard":
                    return _.extend(base, {
                        expMonth: pinfo.expMonth + "",
                        expYear: pinfo.expYear + "",
                        name: pinfo.name,
                        cvv: pinfo.cvv.toString(),
                        idCard: pinfo.idCard && pinfo.idCard.toString(),
					});
				case "Braintree":
					return _.extend(base, {
						providerInfo: {
							nonce: pinfo.nonce,
							deviceData: pinfo.deviceData
						}
					});
				case "giftCard":
					return _.extend(base, {
						cvv: pinfo.cvv,
						cardNum: pinfo.pan ? pinfo.pan : pinfo.number,
						loyaltyApiKey: pinfo.$$loyaltyApiKey ? pinfo.$$loyaltyApiKey : pinfo.loyaltyApiKey
					});
                case "cash":
                    return _.extend(base, {});
                default:
                    return _.extend(base, {});

            }
        }
    };


	getCustomer($storage, includeOrderInstructions) {
		let args = $storage.order;
		//var contact = args.contact;
		let contact = this.appService.contact || $storage.contact;
        var phoneNumber = contact.phone && contact.phone.trim();

        //fit phone for international US/IL use
        // - replace an actual international phone solution on the UI
        if (phoneNumber && (phoneNumber.length > 10) && (phoneNumber[0] !== '+')) {
            if ((phoneNumber[0] === '1') || (phoneNumber.substr(0, 3) === '972'))
                phoneNumber = '+' + phoneNumber;
        }
        //***

        var customer:any = {
            name: contact.name,
            phone: phoneNumber,
            email: contact.email
        };
        if (includeOrderInstructions) {
            customer.dinerCount = contact.dinerCount;
            customer.includeCutlery = contact.includeCutlery;
        }
        var address = args.address;
        if (address) {
            customer.deliveryAddress = {
                city: address.locality,
                street: address.street,
                house: address.streetNumber,
                floor: address.floor && address.floor.toString(),
                apartment: address.appartment && address.appartment.toString(),
                entrance: address.entrance,
                location: address.point,
                notes: address.remarks
            }
            var region = args.region;
            if (region) {
                customer.deliveryAddress.regionId = region.id;
                customer.deliveryAddress.regionName = region.name;
            }
        }
        return customer;
    };

	prepareChck($storage, check) {
		if (check.$$isPrepared) return;
		let order = $storage.order;
		let offers = order.orderedOffers;
		_.each(check.offers, offer => {
			let reffOffer: any = _.find(offers, { _id: offer.orderedOffer });
			offer.name = reffOffer.name;
			offer.price = offer.amount / 100;

			if (offer.rewards) {
				let rewards = 0;
				_.each(offer.rewards, reward => {
					rewards += reward.amount;
				});
				offer.$$rewards = rewards / 100 * -1;
			}
		});

	}

	calculateTimeSlots(timeslots) {
		var activeSlots = {};
		_.each(timeslots, timeslot => {
			var match = this.isTimeslotsActive(timeslot);
			activeSlots[timeslot._id] = match ? true : false;

		});
		return activeSlots;
	}

	isTimeslotsActive(timeslot) {
		var md = moment();
		if (!this.isTimeslotRangeActive(timeslot, md)) return false;
		var d = md.day();

		var dayM = 24 * 60;
		var startThreshhold = 5 * 60;
		var cmd = getMinutes(md);
		if (cmd < startThreshhold) {
			d -= 1;
			if (d < 0) d = 6;
			cmd += dayM;
		}

		let day: any = _.find(timeslot.days, { day: d });
		if (!day.active) return null;
		if (day.type == "allday") return {};
		if (day.type == "default") day = _.find(timeslot.days, { day: -1 });

		day.tslots = [];
		var slotFound;
		for (let i = 0; i < day.slots.length; i++) {
			var slot = day.slots[i];

			slot.from = moment(slot.from);
			slot.to = moment(slot.to);

			slot.tfrom = slot.from.format("HH:mm");
			slot.tto = slot.to.format("HH:mm");

			slot.mfrom = getMinutes(slot.from);
			if (slot.from.date() == 2) slot.mfrom += dayM;
			slot.mto = getMinutes(slot.to);
			if (slot.to.date() == 2) slot.mto += dayM;

			day.tslots.push(slot.tfrom + " - " + slot.tto);

			if (cmd >= slot.mfrom && cmd < slot.mto) {
				slotFound = slot;
				break;
			}
		}
		return slotFound;
		function getMinutes(m) {
			return (m.hours() * 60) + m.minutes();
		}
	}
	isTimeslotRangeActive(slot, md?) {
		if (!slot.limitToDate || !slot.dateRange) return true;
		if (!md) md = moment();
		if (slot.dateRange.startDate && md.isBefore(moment(slot.dateRange.startDate))) return false;
		if (slot.dateRange.endDate && md.isAfter(moment(slot.dateRange.endDate).endOf('day'))) return false;
		return true;
	}

	//------------------------------------------------------------------------------------------>
	// tab order
	//------------------------------------------------------------------------------------------>

	canCreateEatinOrder(config) {
		if (config.eatin?.enabled) {
			if (config.eatin.active) {
				if (this.isDisabledSlotActive(config.eatin)) return false;
				let timeSlot = config.workHours;
				if (timeSlot && this.isTimeslotsActive(timeSlot)) {
					return true;
				}
			}
		}
	}

	canCreateTabOrder(config) {
		//let $storage = this.$storage;
		const tpConfig = config.tabitpay;
		if (!tpConfig.enableCreateTabOrder) return false;
		let timeSlot;
		if (tpConfig.createTabOrder_schedule) timeSlot = _.find(config.timeslots, { _id: tpConfig.createTabOrder_schedule });
		if (!timeSlot) timeSlot = config.workHours;
		if (!this.isTimeslotsActive(timeSlot)) {
			if (this.appService.appConfig.isDev) {
				console.error('Ignoring workhours in dev mode');
			} else {
				return false;
			}

		}
		if (tpConfig.createTabOrder_requireCreditDeposit) {
			tpConfig.preAuthPaymentAccount = 100;
			tpConfig.tabPaymentAccount = _.find(config.paymentAccounts, (pa) => {
				if (pa.paymentType == 'cash' || pa.paymentType == "LeumiPay" || !pa.tabitPayActive || pa.paymentType == "10bis" || pa.paymentType == "giftCard") return false;

				if (pa.schedule) {
					let timeSlot = _.find(config.timeslots, { _id: pa.schedule });
					if (timeSlot && !this.isTimeslotsActive(timeSlot)) return false;
				}
				pa.enableGratuity = pa.enableTabitpayTip === true;

				switch (pa.providerType) {
					case "CreditGuardPaymentProvider":
						pa.supportPreAuthAmount = false;
						pa.paymentType = "CreditGuard";
						pa.fixedPreAuthAmount = 1;
						return true;
					case "AdyenPaymentProvider":
						delete pa.isExternal;
						pa.paymentType = "adyen";
						pa.supportPreAuthAmount = true;
						return true;
				}
			});
			if (!tpConfig.tabPaymentAccount) {
				console.error("Couldn't find credit payment account for shared order!");
				return false;
			}
		}
		return true;
	}

	isDisabledSlotActive(disabledSlot) {
		if (disabledSlot && moment().isBetween(disabledSlot.from, disabledSlot.to)) {
			return true;
		}
	}

}
